module.exports = __webpack_public_path__ + "static/media/login.b2101951.jpg";